import services from "../services";

const strict = true;
const getDefaultState = () => {
  return {
    faqItems: [],
    filteredFaqItems: []
  };
};

const state = getDefaultState();

const getters = {
  faqItems: state => state.faqItems,
  filteredFaqItems: state => state.filteredFaqItems
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  faqItems(state, faqItems) {
    state.faqItems = faqItems;
  },
  filteredFaqItems(state, filteredFaqItems) {
    state.filteredFaqItems = filteredFaqItems;
  },
  searchFaqItems(state, searchQuery) {
    const queryRegexPattern = searchQuery ? searchQuery : ".";
    const regex = new RegExp(queryRegexPattern, "i");
    let results = [];
    state.faqItems.forEach(faqItem => {
      // FILTER USING SEARCH QUERY
      let resultsPerCategory = faqItem.items.filter(
        item => item.question.search(regex) != -1
      );

      if (resultsPerCategory.length > 0) {
        results.push({
          topic: faqItem.topic,
          items: resultsPerCategory
        });
      }
    });
    state.filteredFaqItems = results;
  }
};

const actions = {
  fetchFAQItems({ commit }) {
    services.faqService.fetchFAQItems().then(faqItems => {
      commit("faqItems", faqItems);
      commit("filteredFaqItems", faqItems);
    });
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
